module.exports = __webpack_public_path__ + "img/bancos.033b7117.svg";